"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _ListItem = _interopRequireDefault(require("./ListItem"));

function AddonListItems(_ref) {
  var addons = _ref.addons,
      getFormattedAddon = _ref.getFormattedAddon;
  return addons ? Object.keys(addons).map(function (addonKey) {
    var formattedAddon = getFormattedAddon(addonKey, addons, null);
    if (!formattedAddon) return null;
    var displayLabel = formattedAddon.reviewLabel || formattedAddon.label;
    return _react["default"].createElement(_react.Fragment, {
      key: displayLabel
    }, _react["default"].createElement(_ListItem["default"], {
      key: displayLabel,
      iconName: formattedAddon.icon,
      text: formattedAddon.reviewLabel || formattedAddon.label,
      price: formattedAddon.cost
    }), _react["default"].createElement("hr", {
      className: "list-items__horizontal-line"
    }));
  }) : [null];
}

var _default = (0, _react.memo)(AddonListItems);

exports["default"] = _default;